import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import SlackAccessAuth from '../components/auth/SignInPage/SlackAccess';
import SlackAccessHelpdesk from '../components/auth/SignInPage/SlackAccessHelpdesk';
import SignInForm from '../components/auth/SignInPage/SignInForm';
import SlackAuth from '../components/auth/slackAuth.js';
import SlackJiraAuth from '../components/auth/slackAuthJiraApp';
import SlackStandupAuth from '../components/auth/standupSlackOuath';
import SlackHelpdeskAuth from '../components/auth/helpdeskSlackOauth';
import StripeWrapper from '../components/billing/stripeWrapper';
import GoogleAuth from '../components/auth/googleAuth';
import Appsumo from '../components/Appsumo';
// New Enjo-style auth screens (OTP + cookies). Self-contained module.
import TrooprSignIn from '../components/auth/troopr/TrooprSignIn';
import TrooprSignUp from '../components/auth/troopr/TrooprSignUp';
import EmailVerification from '../components/auth/troopr/EmailVerification';
import TrooprSlackCallback from '../components/auth/troopr/TrooprSlackCallback';
import {
  saveReturnPath,
  readReturnPath,
  withReturnParam,
} from '../components/auth/troopr/returnPath';

// A signed-out deep link lands here: remember it, then go to sign-in.
//
// Only a link from OUTSIDE the app is a return target. A sign-out re-renders the
// current page unauthenticated before its redirect lands, and an expired session
// does the same — capturing those would send the user back to the page they just
// left, so the sign-out would not stick. Both of those arrive with our own origin
// as the referrer; a pasted URL, a bookmark, or a link from Slack or email does
// not, which is the distinction that matters here.
const isExternalEntry = () => {
  try {
    const ref = document.referrer;
    return !ref || new URL(ref).origin !== window.location.origin;
  } catch (e) {
    return true;
  }
};

const accessRedirect = ({ location }) => {
  if (isExternalEntry()) {
    saveReturnPath(location.pathname + location.search + location.hash);
  }
  return <Redirect to={withReturnParam('/troopr/access', readReturnPath(''))} />;
};

// console.log("signi====>")
const signUpRoutes = () => (
  <div>
    <Switch>
      <Route exact path='/slack_login' component={SlackAccessAuth} />
      <Route
        exact
        path='/slack_helpdesk_login'
        component={SlackAccessHelpdesk}
      />
      {/* New Enjo-style sign-in/up + OTP verification */}
      <Route exact path='/troopr/access' component={TrooprSignIn} />
      <Route exact path='/signup' component={TrooprSignUp} />
      <Route exact path='/verification' component={EmailVerification} />
      <Route exact path='/troopr/slack_callback' component={TrooprSlackCallback} />
      {/* Legacy Slack-first sign-in kept available during transition */}
      <Route exact path='/troopr/legacy_access' component={SignInForm} />
      <Route exact path='/appsumo' component={Appsumo} />
      <Route path='/troopr/googleAuth' component={GoogleAuth} />
      <Route path='/slack_auth' component={SlackAuth} />
      <Route path='/slack_jira_auth' component={SlackJiraAuth} />
      <Route path='/slack_standup' component={SlackStandupAuth} />
      <Route path='/slack_helpdesk' component={SlackHelpdeskAuth} />
      <Route exact path='/troopr_billing/:wId' component={StripeWrapper} />
      <Route path='/*' render={accessRedirect} />
    </Switch>
  </div>
);

export default signUpRoutes;
